/** Screens 8 / 8b — nothing matched the applied filter. Mini-chips name
 *  each active type with its count (no ×) joined by AND; a click opens the
 *  popup on that tab; Reset clears everything. */

import { FILTER_TABS, TAB_LABEL, counts as countsOf, type AdsManagerFilter, type FilterTab } from "@/lib/ads-manager-filter";
import { FunnelIcon, TypeIcon } from "./filter-icons";

export function FilterEmptyState({
  noun,
  applied,
  onOpen,
  onReset,
}: {
  noun: string;
  applied: AdsManagerFilter;
  onOpen: (tab: FilterTab) => void;
  onReset: () => void;
}) {
  const c = countsOf(applied);
  const tabs = FILTER_TABS.filter((t) => c[t] > 0);
  return (
    <div className="af-empty">
      <span className="af-empty-icon"><FunnelIcon /></span>
      <div className="af-empty-title">No {noun} match the filters</div>
      <div className="af-empty-chips">
        {tabs.map((t, i) => (
          <span key={t} style={{ display: "contents" }}>
            {i > 0 && <span className="af-and">AND</span>}
            <button type="button" className="af-pill" onClick={() => onOpen(t)}>
              <TypeIcon tab={t} />
              {TAB_LABEL[t]}
              <span className="count">{c[t]}</span>
            </button>
          </span>
        ))}
      </div>
      <button type="button" className="af-btn" onClick={onReset}>Reset filter</button>
    </div>
  );
}
